import { CheckboxField } from '../Fields/CheckboxField';
import { HookedForm } from '../HookedForm';
import { ListInterface } from '@app/models/util';
import { Pagination } from '../Pagination/Pagination';
import { ListRow } from '../ListRow/ListRow';
import DeleteIcon from '@app/assets/icons/bin.svg?react';
import AddCustomersIcon from '@app/assets/icons/add-customers.svg?react';
import { SortableHeader } from '../GenericTable/SortableHeader';

const tableHeader = [
  { label: 'LIST', field: 'name' },
  { label: 'ID', field: 'id' },
  { label: 'CUSTOMERS', field: 'customers' },
  { label: 'CREATION DATE', field: 'createdAt' },
];

interface ListTableInterface {
  lists: ListInterface[];
  handleNextPage: (value: number) => void;
  handlePrevPage: (value: number) => void;
  handleLimit: (value: number) => void;
  handleListSelect: (value: string | undefined) => void;
  total: number;
  page: number;
  refresh?: () => void;
  handleAddCustomersToList?: () => void;
  selectedLists?: string[];
  simplified?: boolean;
  handleDeleteListModal?: () => void;
  handleDeleteList?: (id: string) => void;
  sortable?: boolean;
  currentSortBy?: string;
  currentSortOrder?: 'asc' | 'desc';
  onSort?: (field: string) => void;
}

export const ListsTable = ({
  lists,
  handleNextPage,
  handlePrevPage,
  handleLimit,
  total,
  page,
  handleListSelect,
  handleAddCustomersToList,
  selectedLists,
  simplified,
  handleDeleteListModal,
  handleDeleteList,
  sortable = false,
  currentSortBy,
  currentSortOrder,
  onSort,
}: ListTableInterface) => {

  const [hasSelected] = selectedLists ?? [];
  return (
    <div className="bg-white overflow-x-auto">
      <HookedForm>
        <table className="w-full">
          <thead>
            <tr className="border-b border-base-antiFlash ">
              <th className="pl-4 pr-0 py-4 min-w-fit w-0">
                <CheckboxField
                  onCheckMark={handleListSelect}
                  name="lists"
                  value="all"
                  checked={lists.length === selectedLists?.length}
                />
              </th>
              {hasSelected && !simplified && (
                <th
                  colSpan={5}
                  className="text-sm text-brand-baseBlue font-medium p-4"
                  align="left"
                >
                  <div className="flex gap-4 ">
                    <button
                      onClick={() =>
                        handleAddCustomersToList && handleAddCustomersToList()
                      }
                      className="flex items-center gap-1"
                    >
                      <AddCustomersIcon className="[&_path]:fill-[#7fc9fe]" />{' '}
                      Add customer(s) to list
                    </button>
                    <button className="flex items-center gap-1" onClick={() => handleDeleteListModal && handleDeleteListModal()}>
                      <DeleteIcon /> Delete list(s)
                    </button>
                  </div>
                </th>
              )}
              {(simplified || !hasSelected) && (
                <>
                  {tableHeader.map((item) => (
                    sortable && onSort ? (
                      <SortableHeader
                        key={item.field}
                        label={item.label}
                        field={item.field}
                        currentSortBy={currentSortBy}
                        currentSortOrder={currentSortOrder}
                        onSort={onSort}
                      />
                    ) : (
                      <th
                        key={item.field}
                        className="px-0 py-4 text-xs font-medium text-left text-base-coolGray"
                      >
                        {item.label}
                      </th>
                    )
                  ))}
                </>
              )}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lists?.map((list) => {
              return (
                <ListRow
                  key={list.id}
                  data={list}
                  handleDeleteList={handleDeleteList}
                  handleCheckbox={handleListSelect}
                  selectedLists={selectedLists}
                  simplified={simplified}
                />
              );
            })}
          </tbody>
        </table>
        <Pagination
          handleLimitChange={handleLimit}
          handleNextPage={handleNextPage}
          handlePrevPage={handlePrevPage}
          page={page}
          total={total}
        />
      </HookedForm>
    </div>
  );
};
